<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.1709 12.1333V16.6667C17.1709 17.1333 16.8042 17.5 16.3375 17.5H3.67086C3.20419 17.5 2.83752 17.1333 2.83752 16.6667V12.1333C2.83752 11.6667 3.20419 11.3 3.67086 11.3C4.13752 11.3 4.50419 11.6667 4.50419 12.1333V15.8333H15.5042V12.1333C15.5042 11.6667 15.8709 11.3 16.3375 11.3C16.8042 11.3 17.1709 11.6667 17.1709 12.1333ZM9.40419 13.1667C9.55419 13.3333 9.77086 13.4167 10.0042 13.4167C10.2375 13.4167 10.4375 13.3333 10.6042 13.1667L13.9209 9.76668C14.2375 9.43335 14.2375 8.91667 13.9042 8.58333C13.5709 8.26667 13.0542 8.26668 12.7209 8.60002L10.8209 10.5333V3.33333C10.8209 2.86667 10.4542 2.5 9.98753 2.5C9.52086 2.5 9.15419 2.86667 9.15419 3.33333V10.55L7.25419 8.61666C6.93752 8.28333 6.40419 8.28335 6.07086 8.60002C5.73753 8.91668 5.73753 9.44999 6.0542 9.78333L9.40419 13.1667Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: 'downloadIcon',
    props: {
      fill: {
        type: String,
        default: '#00527F'
      }
    }
  }
</script>

<style scoped>
  svg:hover path {
    fill: #29ABE2;
  }
</style>
